const editUrl = (existingUrl, id) => {
  const url = existingUrl;
  if (id) {
    return url.replace(':id', id);
  }
  return url;
};

export default editUrl;
